import React from 'react';
import { Modal, Message, Button, Input } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import styles from './SupportModal.module.scss';
import { useForm } from '../../hooks';

import api from '../../api';

const SupportModal = React.memo(({ onCreate, onClose }) => {
  const [message, setMessage] = React.useState(null);
  const [data, handleFieldChange, setData] = useForm(() => ({
    username: '',
    email: '',
    name: '',
    id: '',
  }));
  const onSubmit = () => {
    const { id } = data;
    onCreate(id);
  };

  const onSearchUsername = () => {
    setMessage(null);
    if (data.username) {
      api
        .findSupportName({
          username: data.username,
        })
        .then((res) => {
          setData((prevData) => {
            const newData = { ...prevData };
            newData.name = res.item.name;
            newData.id = res.item.id;
            return newData;
          });
        })
        .catch(() => {
          setMessage('未找到对应用户');
          setData((prevData) => {
            const newData = { ...prevData };
            newData.id = '';
            newData.name = '';
            return newData;
          });
        });
    }
  };

  const onSearchEmail = () => {
    setMessage(null);
    if (data.email) {
      api
        .findSupportName({
          email: data.email,
        })
        .then((res) => {
          setData((prevData) => {
            const newData = { ...prevData };
            newData.name = res.item.name;
            newData.id = res.item.id;
            return newData;
          });
        })
        .catch(() => {
          setMessage('未找到对应用户');
          setData((prevData) => {
            const newData = { ...prevData };
            newData.id = '';
            newData.name = '';
            return newData;
          });
        });
    }
  };
  return (
    <Modal open closeIcon size="small" centered={false} onClose={onClose}>
      <Modal.Header>新增支持账号</Modal.Header>
      <Modal.Content scrolling>
        {message && (
          <Message
            negative
            onDismiss={() => {
              setMessage(null);
            }}
          >
            {message}
          </Message>
        )}
        <span className={styles.text}>用户名</span>
        <Input
          name="username"
          type="text"
          placeholder="请输入用户名"
          onChange={handleFieldChange}
          action={{
            content: '搜索',
            onClick: onSearchUsername,
          }}
        />
        <span className={styles.text} style={{ marginTop: '10px' }}>
          邮箱
        </span>
        <Input
          name="email"
          type="text"
          placeholder="请输入邮箱"
          onChange={handleFieldChange}
          action={{
            content: '搜索',
            onClick: onSearchEmail,
          }}
          style={{ marginBottom: '10px' }}
        />
        <span className={styles.text}>姓名</span>
        <Input name="name" type="text" placeholder="-" readOnly value={data.name} />
      </Modal.Content>
      <Modal.Actions>
        <Button primary onClick={onSubmit}>
          新增
        </Button>
        <Button onClick={onClose}>取消</Button>
      </Modal.Actions>
    </Modal>
  );
});
SupportModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
};

export default SupportModal;
